<ng-container *ngIf="message$ | async as message">

  <div *ngIf="message.icon" class="icon-shadowed">
    <img src="/assets/{{ message.icon }}.svg">
  </div>

  <div class="message">
    <div *ngIf="message.title" class="title">{{ message.title }}</div>
    <div *ngIf="message.body" class="text" [innerHtml]="message.body | safeHtml"></div>
  </div>

</ng-container>
